import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, setBlockTracking as _setBlockTracking, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "flex justify-between items-center w-full" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["aria-label", "title"];
const _hoisted_4 = { class: "py-1" };
import { ref } from 'vue';
import { ___ } from '@ts/common/language';
import SvgVue from '@ts/components/utils/SvgVue.vue';
import { DefaultPropValues } from '@ts/components/form/types';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LabelWithHelp',
    props: {
        title: { default: DefaultPropValues.title },
        help: { default: DefaultPropValues.help },
        disabled: { type: Boolean, default: DefaultPropValues.disabled },
        invalid: { type: Boolean },
        small: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const showHelp = ref(false);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("label", {
                        class: _normalizeClass(["label mb-0", { 'invalid': props?.invalid === true, 'text-sm': props.small === true }]),
                        innerHTML: __props.title
                    }, null, 10 /* CLASS, PROPS */, _hoisted_2),
                    (__props.help.trim() !== '')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = ($event) => (showHelp.value = !showHelp.value)),
                            type: "button",
                            class: "btn text-gray-350 dark:text-gray-450 hover:text-primary-500",
                            "aria-label": _unref(___)({ en: 'Toggle help', de: 'Hilfe ein- und ausblenden' }),
                            title: _unref(___)({ en: 'Help', de: 'Hilfe' })
                        }, [
                            _cache[0] || (_setBlockTracking(-1, true),
                                (_cache[0] = _createVNode(SvgVue, {
                                    class: "w-4 h-4",
                                    icon: "lucide/circle-question-mark"
                                })).cacheIndex = 0,
                                _setBlockTracking(1),
                                _cache[0])
                        ], 8 /* PROPS */, _hoisted_3))
                        : _createCommentVNode("v-if", true)
                ]),
                (__props.help.trim() !== '')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["collapsible", { expanded: showHelp.value }])
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["text-muted collapsible-content", { 'text-sm': props.small === true }])
                        }, [
                            _createElementVNode("div", _hoisted_4, _toDisplayString(__props.help), 1 /* TEXT */)
                        ], 2 /* CLASS */)
                    ], 2 /* CLASS */))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
